import { useEmployeeQuery } from '@jbc-year-end-adj/2024/hooks/graphql/useQuery';
import { Question } from '@jbc-year-end-adj/2024/features/questions/types';
import { LoadingPage } from '../../Loading';
import { Form } from './Form';
import { FC } from 'react';
import { gql } from '@apollo/client';

interface OtherIncomeTypeProps {
  question: Question;
}

const INCOME = gql`
  query income {
    request {
      id
      profile {
        id
        income {
          id
          hasBusinessIncome
          hasMiscellaneousIncome
          hasDividendIncome
          hasRealEstateIncome
          hasRetirementIncome
          hasOtherIncome
        }
      }
    }
  }
`;

export const OtherIncomeType: FC<OtherIncomeTypeProps> = ({ question }) => {
  const { loading, data } = useEmployeeQuery(INCOME);
  const income = data?.request?.profile?.income;
  if (loading) return <LoadingPage />;
  return <Form income={income} question={question} />;
};
